import { render } from "./ConfirmDelete.vue?vue&type=template&id=5f2f1d0d&scoped=true"
import script from "./ConfirmDelete.vue?vue&type=script&lang=js"
export * from "./ConfirmDelete.vue?vue&type=script&lang=js"

import "./ConfirmDelete.vue?vue&type=style&index=0&id=5f2f1d0d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f2f1d0d"

export default script